import { useTranslation } from 'react-i18next';

export enum BUSINESS_SECTOR {
  INSURANCE = 'insurance',
  CREDIT_AND_FINANCE = 'credit and finance',
  OTHER_BUSINESS_SERVICES = 'otherBusinessServices',
  ASSOCIATIONS = 'associations',
  TRADE_AND_GDO = 'trade and GDO',
  CONSULTANCY = 'consultancy',
  BUILDING_AND_CONSTRUCTION = 'building and construction',
  PUBLISHING_MEDIA_AND_COMMUNICATION = 'publishing, media and communication',
  ENERGY = 'energy',
  FOOD_INDUSTRY = 'food Industry',
  WOOD_AND_FURNITURE = 'wood and furniture industry',
  CHEMICAL_AND_PHARMACEUTICAL_INDUSTRY = 'chemical and pharmaceutical industry',
  GENERIC_INDUSTRY = 'generic Industry',
  MECHANICAL_INDUSTRY = 'mechanical industry, metallurgy',
  TEXTILE_INDUSTRY = 'textile industry, clothing',
  INFORMATION_TECHNOLOGY = 'information technology',
  MEDICINE_AND_HEALTHCARE = 'medicine and healthcare',
  CENTRAL_OR_LOCAL_PA = 'Central_or_Local_PA',
  PUBLIC_UTILITIES = 'public utilities',
  SYNDICATE = 'syndicate',
  MANAGEMENT_TRAINING_COMPANY = 'management training company',
  TRANSPORT_AND_LOGISTICS = 'transport and logistics',
  TOURISM_HOTELS_AND_LEISURE = 'tourism, hotels and leisure',
  UNIVERSITY_EDUCATION_AND_RESEARCH = 'university, education and research',
}

export enum N_OF_EMPLOYEES {
  ONE_TO_TEN = '1-10',
  ELEVEN_TO_FIFTY = '11-50',
  FIFTY_ONE_TO_ONE_HUNDRED = '51-100',
  ONE_HUNDRED_AND_ONE_TO_TWOHUNDRED_FIFTY = '101-250',
  TWOHUNDRED_FIFTY_ONE_TO_FIVE_HUNDRED = '251-500',
  FIVE_HUNDRED_ONE_TO_ONETHOUSAND = '501-1000',
  ONETHOUSAND_ONE_TO_TWOTHOUSAND_AND_FIVEHUNDRED = '1001-2500',
  TWOTHOUSAND_AND_FIVEHUNDRED_ONE_TO_FIVE_THOUSANDS = '2501-5000',
  MORE_THAN_FIVE_THOUSANDS = '5000+',
}

export interface SubscriptionNote {
  id: string;
  text: string;
  createdAt: string;
  createdBy?: string;
}

export interface SubscriptionPeriod {
  id: string;
  startDate: string;
  endDate: string;
  /** Importo totale pagato per l'intero periodo di canone in € */
  totalAmount: number;
  /** Durata del canone in mesi (auto-derivabile da date, editabile) */
  months?: number;
  /** Importo per singola utenza (totalAmount / months / seats), editabile */
  amountPerSeat?: number;
  /** Numero di utenze */
  seats: number;
  notes: SubscriptionNote[];
  reminderSentAt?: string;
  createdAt: string;
}

export interface Company {
  id: string;
  name: string;
  enabled: boolean;
  headOfficeCity: string;
  headOfficeRegion: string;
  vatNumber: string;
  nOfEmployees: N_OF_EMPLOYEES;
  businessSector: BUSINESS_SECTOR;
  otherOfficies: { city: string; region: string }[];
  libraryEnabled: boolean;
  subscriptions?: SubscriptionPeriod[];
  subscriptionCcEmails?: string[];
}

export type CompanyResponse = Company & {
  hrName: string;
  hrSurname: string;
  hrEmail: string;
  hrPhone: string;
  staffToken: string;
  limit: number;
  skip: number;
  hrLanguage: string;
  libraryEnabled: boolean;
};

export type CompanyPayload = Omit<CompanyResponse, 'id' | 'enabled'>;

export interface IErrorsCompanies {
  value: string;
  msg: string;
  param: string;
  location: string;
}

export const sectors: { [key: string]: string }[] = Object.keys(
  BUSINESS_SECTOR
).map((key) => ({
  [key]: BUSINESS_SECTOR[key as keyof typeof BUSINESS_SECTOR],
}));

export const nOfEmployees: { [key: string]: string }[] = Object.keys(
  N_OF_EMPLOYEES
).map((key) => ({
  [key]: N_OF_EMPLOYEES[key as keyof typeof N_OF_EMPLOYEES],
}));
